import { render, staticRenderFns } from "./List.vue?vue&type=template&id=26b06572&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=26b06572&scoped=true&lang=less&"
import style1 from "./List.vue?vue&type=style&index=1&id=26b06572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b06572",
  null
  
)

export default component.exports